import { render, staticRenderFns } from "./commonSelect.vue?vue&type=template&id=32a1c568"
import script from "./commonSelect.vue?vue&type=script&lang=js"
export * from "./commonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports